import React, { useState } from 'react';

interface IInviteUser {
  user: any;
  setInviteMode: any;
  sendInvite: any;
}

const InviteUserModal: React.FC<IInviteUser> = ({ user, setInviteMode, sendInvite }) => {
  const [ formValues, setFormValues ] = useState<any>({
    email: ''
  });
  return (
    <div className='invite-user-modal-container'>
      <div className='invite-user-modal-header'>
        <div className='invite-user-modal-header-content'>
          <div className='invite-user-modal-header-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M19 10V4M16 7H22M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='invite-user-modal-header-text-group'>
            <div className='invite-user-modal-header-text-primary'>
              Invite User
            </div>
            <div className='invite-user-modal-header-text-secondary'>
              Enter the new member email to send an invite.
            </div>
          </div>
        </div>
        <div className='invite-user-modal-close' onClick={() => setInviteMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='invite-user-modal-body'>
        <div className='invite-user-modal-body-row'>
          <div className='invite-user-modal-body-row-title'>
            <div className='invite-user-modal-body-row-title-text'>
              Email
            </div>
          </div>
          <div className='invite-users-input-and-drop' style={{ width: '100%' }}>
            <div className='invite-users-input-field'>
              <input
                id='email'
                placeholder=''
                type='text'
                className='create-team-name-input'
                name='email'
                value={formValues.email}
                onChange={(e) => setFormValues({
                  ...formValues,
                  email: e.target.value,
                })}
              />
            </div>
          </div>
        </div>
        {/* <div className='invite-user-modal-body-row'>
          <div className='invite-user-modal-body-row-title'>
            <div className='invite-user-modal-body-row-title-text'>

            </div>
          </div>
        </div> */}
      </div>
      <div className='invite-user-modal-footer'>
        <div className='invite-user-modal-footer-content'>
          <div className='invite-user-modal-footer-cancel' onClick={() => setInviteMode(false)}>
            <div className='invite-user-modal-footer-cancel-text'>
              Cancel
            </div>
          </div>
          <div className='invite-user-modal-footer-send' onClick={() => sendInvite(formValues)}>
            <div className='invite-user-modal-footer-send-text'>
              Send Invite
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteUserModal;
